import { atomWithReset } from 'jotai/utils'

export const mailLoginRedirect = atomWithReset<string>('/mail/inbox')
